import Vue from 'vue'

export function showToast(payload) {
    Vue.notify({
        group: 'appNotif',
        title: 'Success',
        text: payload.data.message,
        type: 'success'
    })
}